<template>
  <div class="multiselect-dropdown" :class="{ 'is-invalid': isInvalid }" ref="dropdown">
    <div class="dropdown-toggle" @click="toggleDropdown">
      <span v-if="selectedOptions.length === 0">{{ placeholder }}</span>
      <span v-else>{{ selectedOptions.map(opt => opt.label).join(", ") }}</span>
      <i class="ti ti-chevron-down"></i>
    </div>
    <div v-if="isOpen" class="dropdown-menu">
      <label v-for="option in options" :key="option.value" class="dropdown-item">
        <input type="checkbox" :value="option.value" :checked="isSelected(option)" @change="toggleOption(option)" />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MultiSelectDropdown",
    props: {
      options: {
        type: Array,
        required: true, // e.g., [{ value: 'email', label: 'Email' }]
      },
      modelValue: {
        type: Array,
        required: true, // array of selected values, e.g., ['email']
      },
      placeholder: {
        type: String,
        default: "Select...",
      },
      isInvalid: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    data() {
      return {
        isOpen: false,
      };
    },
    computed: {
      selectedOptions() {
        return this.options.filter(opt => this.modelValue.includes(opt.value));
      },
    },
    methods: {
      toggleDropdown() {
        this.isOpen = !this.isOpen;
      },
      closeDropdown() {
        this.isOpen = false;
      },
      isSelected(option) {
        return this.modelValue.includes(option.value);
      },
      toggleOption(option) {
        const newValue = [...this.modelValue];
        const index = newValue.indexOf(option.value);
        if (index > -1) {
          newValue.splice(index, 1);
        } else {
          newValue.push(option.value);
        }
        this.$emit("update:modelValue", newValue);
      },
      handleClickOutside(event) {
        if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
          this.isOpen = false;
        }
      },
    },
    mounted() {
      document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
      document.removeEventListener("click", this.handleClickOutside);
    },
  };
</script>

<style scoped>
  .multiselect-dropdown {
    position: relative;
    width: 100%;
    background-color: #fff;
    cursor: pointer;
  }

  .multiselect-dropdown.is-invalid .dropdown-toggle {
    border-color: #dc3545;
  }

  .dropdown-toggle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0.75rem;
    min-height: 45px;
    border: 1px solid #ced4da;
    border-radius: 25px;
    transition:
      border-color 0.15s ease-in-out,
      box-shadow 0.15s ease-in-out;
  }

  .dropdown-toggle span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #6c757d;
    font-size: 14px;
  }

  .dropdown-toggle i {
    color: #ff5722;
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    display: block;
    width: 100%;
    padding: 0.5rem 0;
    margin: 0.125rem 0 0;
    font-size: 1rem;
    color: #212529;
    text-align: left;
    list-style: none;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .dropdown-item {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 0.25rem 1rem;
    clear: both;
    font-weight: 400;
    color: #212529;
    text-align: inherit;
    white-space: nowrap;
    background-color: transparent;
    border: 0;
    cursor: pointer;
  }

  .dropdown-item:hover {
    background-color: #f8f9fa;
  }

  .dropdown-item input[type="checkbox"] {
    margin-right: 0.5rem;
  }
</style>
